import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ApiInterceptor } from '@digilize/shared/feature/modules/auth/src';
import { APP_CONFIG, ENV_CONFIG } from '@digilize/shared/utils/tokens/src';
import { InlineSVGModule } from '@digilize/shared/ui/inline-svg/src';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';

import { appConfig } from '../environments/app.config';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './components/shared.module';
import { TranslocoRootModule } from './transloco-root.module';
import { AlertService } from '@digilize/shared/feature/modules/alert/src';

@NgModule({
  declarations: [AppComponent],
  exports: [],
  imports: [
    BrowserModule,
    AppRoutingModule,
    InlineSVGModule.forRoot({ baseUrl: '/assets' }),
    TranslocoRootModule,
    RecaptchaV3Module,
    SharedModule,
  ],
  providers: [
    AlertService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    {
      provide: ENV_CONFIG,
      useValue: environment,
    },
    {
      provide: APP_CONFIG,
      useValue: appConfig,
    },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
